import { render, staticRenderFns } from "./AdvancementRederer.vue?vue&type=template&id=3539fe66&scoped=true&"
import script from "./AdvancementRederer.vue?vue&type=script&lang=ts&"
export * from "./AdvancementRederer.vue?vue&type=script&lang=ts&"
import style0 from "./AdvancementRederer.vue?vue&type=style&index=0&id=3539fe66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3539fe66",
  null
  
)

export default component.exports